import { useResolvedPath, Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Toolbar, IconButton, Typography, Stack, AppBar, styled, Link } from "@mui/material";
import UserTopAvatar from "./UserTopAvatar";
import { HistoryBackIconButton } from "../lib/common";
import RouteNames from "../config/RouteNames";
import EnvironmentLabel from "./EnvironmentLabel";
import PhotoUploadStatusButton from "./PhotoUploadStatusButton";
import useDocumentTitle from "../lib/hooks/useDocumentTitle";
import { useMobileScreen } from "../lib/hooks";

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `100%`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function TopBar({ drawerDisabled, toggleDrawer, open, title }) {
  const { pathname: route } = useResolvedPath();
  useDocumentTitle();
  const { isMobile } = useMobileScreen();

  let drawerButton;
  if (!drawerDisabled) {
    drawerButton = (
      <IconButton
        edge="start"
        color="inherit"
        aria-label="open drawer"
        onClick={toggleDrawer}
        sx={{
          marginRight: 2,
          ...(open && !isMobile && { display: "none" }),
        }}>
        <MenuIcon />
      </IconButton>
    );
  }

  return (
    <StyledAppBar color="secondary" position="sticky" open={open} sx={{ displayPrint: "none" }}>
      <Toolbar
        sx={{
          pr: "24px", // keep right padding when drawer closed
        }}>
        {drawerButton}
        <HistoryBackIconButton color="inherit" aria-label="Zpět" edge="start" sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </HistoryBackIconButton>

        <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
          <Link
            component={RouterLink}
            to="/"
            sx={{
              flexGrow: 1,
              textDecoration: "none",
              color: "inherit",
              "&:hover": { textDecoration: "underline", textUnderlineOffset: 3 },
            }}>
            {title || RouteNames[route] || RouteNames["/"]}
          </Link>
        </Typography>

        <Stack direction={"row"} spacing={2} alignItems={"center"}>
          <PhotoUploadStatusButton />
          <EnvironmentLabel />
          <IconButton component={RouterLink} to="/support" color="inherit" aria-label="Podpora">
            <HelpOutlineIcon />
          </IconButton>
          <UserTopAvatar />
        </Stack>
      </Toolbar>
    </StyledAppBar>
  );
}

export default TopBar;
